import { IAnyObject } from "../interfaces";

export class Alarm {
  public sensor: string;
  public timestamp: number;
  public clearedBy: string;
  public clearedTimestamp: number;
  public reason: string;
  public displayName: string;

  constructor(data: IAnyObject) {
    this.sensor = data.sensor as string;
    this.timestamp = data.timestamp as number;
    this.clearedBy = data.clearedBy as string;
    this.clearedTimestamp = data.clearedTimestamp  as number;
    this.reason = data.reason as string;
    this.displayName = data.displayName as string;
  }
}
